export function isEmptyValue(value: string): boolean {
    return value.trim().length === 0;
}

export function isValidEmail(email: string): boolean {
    const emailRE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRE.test(String(email).toLowerCase());
}


export function isValidKoreanPhone(phone: string): boolean {
    const cleanedPhone = phone.replace(/[^0-9]/g, '');
    console.error('implement phone validation (Korean temp hack)');
    console.debug(cleanedPhone);

    if (cleanedPhone.length < 12) {
        return false;
    }

    return true;
}

export function isValidPassword(password: string): boolean {
    return isEmptyValue(password) === false;
}

